module.exports = __webpack_public_path__ + "img/message-icon.98e79eab.svg";